import { render, staticRenderFns } from "./FastProductArrivalData.vue?vue&type=template&id=2e39c582&scoped=true&"
import script from "./FastProductArrivalData.vue?vue&type=script&lang=js&"
export * from "./FastProductArrivalData.vue?vue&type=script&lang=js&"
import style0 from "./FastProductArrivalData.vue?vue&type=style&index=0&id=2e39c582&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e39c582",
  null
  
)

export default component.exports